import { ReactComponent as PlayIcon } from "./play.svg";
import { ReactComponent as BackIcon } from "./back.svg";
import { ReactComponent as DeleteIcon } from "./delete.svg";
import { ReactComponent as DeleteRedIcon } from "./delete-red.svg";
import { ReactComponent as InfoIcon } from "./info.svg";
import { ReactComponent as ChevronLeftIcon } from "./chevron-left.svg";
import { ReactComponent as ChevronDownIcon } from "./chevron-down.svg";
import { ReactComponent as ChevronRightIcon } from "./chevron-right.svg";
import { ReactComponent as CrossIcon } from "./cross.svg";
import { ReactComponent as PaperPlane } from "./paper-plane.svg";

export const Icons = {
  PlayIcon,
  BackIcon,
  InfoIcon,
  CrossIcon,
  DeleteIcon,
  DeleteRedIcon,
  ChevronLeftIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  PaperPlane,
};
